module.exports = __webpack_public_path__ + "media/assets_v3/images/csgo-ranks/5-838a00e5b9fdde4b4ad929f7b63d452a.png";